import storageService from './storageService';
import {
    COMPAT_KEYS,
    OIDC_SESSION_PREFIX,
    STORAGE_BACKENDS,
    STORAGE_DOMAINS,
    STORAGE_KEYS,
    STORAGE_NAMESPACE,
    createNamespacedKey
} from './storageKeys';
import {
    cacheUserPayload,
    clearAuthAndSessionState,
    getAuthSession,
    getSsoInFlight,
    getUserName,
    isLoggedIn,
    resolveSsoLoginData,
    setAuthSession,
    setSsoInFlight
} from './authStorage';
import {
    getFamSelectedColumns,
    getToggleState,
    getUserSelectedColumns,
    getVideoToggleState,
    hasWindowStorage,
    setFamSelectedColumns,
    setToggleState,
    setUserSelectedColumns,
    setVideoToggleState
} from './prefsStorage';
import { getCookie, hasCookie, setCookie } from './cookieStorage';

const defaultDomain = STORAGE_DOMAINS.CACHE;

export const get = (key, fallbackValue = null, options = {}) => {
    const { backend = STORAGE_BACKENDS.LOCAL, parse = 'auto' } = options;
    const rawValue = storageService.readRaw(key, backend);

    if (rawValue === null || rawValue === undefined) {
        return fallbackValue;
    }

    if (parse === false) {
        return rawValue;
    }

    if (parse === true) {
        const parsedValue = storageService.safeJsonParse(rawValue, fallbackValue);
        return parsedValue === undefined || parsedValue === null ? fallbackValue : parsedValue;
    }

    try {
        return JSON.parse(rawValue);
    } catch (error) {
        return rawValue;
    }
};

export const set = (key, value, domain = defaultDomain, options = {}) => {
    const { backend = STORAGE_BACKENDS.LOCAL } = options;
    const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
    storageService.writeRaw(key, serializedValue, backend, domain);
};

export const remove = (key, domain = defaultDomain, options = {}) => {
    const { backend = STORAGE_BACKENDS.LOCAL } = options;
    storageService.removeRaw(key, backend, domain);
};

export const subscribeToKey = storageService.subscribeToKey;
export const subscribeToDomain = storageService.subscribeToDomain;
export const clearDomain = storageService.clearDomain;

export {
    STORAGE_NAMESPACE,
    STORAGE_BACKENDS,
    STORAGE_DOMAINS,
    STORAGE_KEYS,
    COMPAT_KEYS,
    OIDC_SESSION_PREFIX,
    createNamespacedKey,
    getAuthSession,
    setAuthSession,
    cacheUserPayload,
    clearAuthAndSessionState,
    isLoggedIn,
    getUserName,
    setSsoInFlight,
    getSsoInFlight,
    resolveSsoLoginData,
    getToggleState,
    setToggleState,
    getVideoToggleState,
    setVideoToggleState,
    getUserSelectedColumns,
    setUserSelectedColumns,
    getFamSelectedColumns,
    setFamSelectedColumns,
    hasWindowStorage,
    getCookie,
    hasCookie,
    setCookie
};

export const auth = {
    getAuthSession,
    setAuthSession,
    cacheUserPayload,
    clearAuthAndSessionState,
    isLoggedIn,
    getUserName,
    setSsoInFlight,
    getSsoInFlight,
    resolveSsoLoginData
};

export const prefs = {
    getToggleState,
    setToggleState,
    getVideoToggleState,
    setVideoToggleState,
    getUserSelectedColumns,
    setUserSelectedColumns,
    getFamSelectedColumns,
    setFamSelectedColumns,
    hasWindowStorage
};

export const cookies = {
    getCookie,
    hasCookie,
    setCookie
};

export const keys = {
    STORAGE_NAMESPACE,
    STORAGE_BACKENDS,
    STORAGE_DOMAINS,
    STORAGE_KEYS,
    COMPAT_KEYS,
    OIDC_SESSION_PREFIX,
    createNamespacedKey
};

export const events = {
    subscribeToKey,
    subscribeToDomain,
    clearDomain
};

const GQStorage = {
    get,
    set,
    remove,
    subscribeToKey,
    subscribeToDomain,
    clearDomain,
    auth,
    prefs,
    cookies,
    keys,
    events
};

export default GQStorage;